export enum EvaluationNavSections {
  overview = 'overview',
  tests = 'tests',
  surveys = 'surveys',
}
